import PropTypes from 'prop-types';
import { Popover, MenuItem } from '@mui/material';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function ActionsPopover({
  open,
  onClose,
  onViewClick,
  onEditClick,
  onDeleteClick,
  canEdit = true,
  canDelete = true,
}) {
  return (
    <Popover
      open={Boolean(open)}
      anchorEl={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { width: 160 },
      }}
    >
      <MenuItem onClick={onViewClick}>
        <Iconify icon="eva:eye-fill" sx={{ mr: 2 }} />
        View
      </MenuItem>

      {canEdit && (
        <MenuItem onClick={onEditClick}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>
      )}

      {canDelete && (
        <MenuItem onClick={onDeleteClick} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      )}
    </Popover>
  );
}

ActionsPopover.propTypes = {
  open: PropTypes.node,
  onClose: PropTypes.func,
  onViewClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
};
